import AppSearchAPIConnector from "@elastic/search-ui-app-search-connector";
import {
  buildAutocompleteQueryConfig,
  buildSearchOptionsFromConfig,
  getConfig,
  buildFacetConfigFromConfig,
} from "./faq-config-helper";
import appConfig from "../../config";

const { hostIdentifier, searchKey, endpointBase, engineName } = getConfig();
const connector = new AppSearchAPIConnector({
  searchKey,
  engineName,
  hostIdentifier,
  endpointBase,
});

/**
 * highlight: {
          fields: {
            "*": {
              "pre_tags": ["<b>"],
              "post_tags": ["</b>"]
           }
         }
        }
 */
const config = {
  searchQuery: {
    filters: [
      // { field: "bundle_type", values: ["faq"] },
      { field: "language_code", values: [appConfig.appLanguage] }, // ja, kr, sg, eu, us, cn
    ],
    facets: buildFacetConfigFromConfig(),
    ...buildSearchOptionsFromConfig(),
  },
  autocompleteQuery: buildAutocompleteQueryConfig(),
  apiConnector: connector,
  alwaysSearchOnInitialLoad: true,
  trackUrlState: false,
  initialState: {
    resultsPerPage: 10,
  },
  onSearch: (state, queryConfig, next) => {
    return next(
      {
        ...state,
        searchTerm: state.searchTerm.slice(0, 100),
      },
      queryConfig,
    );
  },
};

export default config;
